import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=7f0535a0&scoped=true&"
import script from "./BaseLayout.vue?vue&type=script&lang=js&"
export * from "./BaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=7f0535a0&scoped=true&lang=css&"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0535a0",
  null
  
)

export default component.exports